module.exports = __webpack_public_path__ + "8893c86b21cbb00eca3f3d248d7915f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/hochformat/05.jpg
// module id = 142
// module chunks = 0